import { MathJax } from "better-react-mathjax";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

function Soal({
  id,
  question,
  answer,
  key,
  key_soal,
  is_answer,
  option,
  num,
  user_key,
  userKeyHandler,
  isAnswerPage = false,
}) {
  const [user_key_state, setUser_key_state] = useState(0);
  const [isAnswerClass, setIsAnswerClass] = useState(null);
  const [isShowAnswer, setIsShowAnswer] = useState(false);

  const location = useLocation();

  useEffect(() => {
    if (isAnswerPage) {
      if (user_key != 0) {
        if (user_key == key_soal) {
          setIsAnswerClass("box_green");
        } else if (user_key != key_soal) {
          setIsAnswerClass("box_red");
        }
      }
    }
  }, []);

  useEffect(() => {
    userKeyHandler(id, user_key_state);
    // console.log(`location ${}`)
  }, [user_key_state]);

  return (
    <MathJax>
      <div className="container">
        <div className="header">
          <div className="right-section">
            <div className={`box ${isAnswerClass}`}>{num + 1}</div>
          </div>
        </div>

        <div className="soal">
          <div
            className="text"
            dangerouslySetInnerHTML={{ __html: question }}
          ></div>

          <div className="options">
            <div
              onClick={() =>
                user_key_state != 1
                  ? setUser_key_state(1)
                  : setUser_key_state(0)
              }
              class={`option ${user_key == 1 && "choice"} ${
                isAnswerPage && key_soal == 1 && "true_choice"
              }`}
            >
              <div class="circle">1</div>
              <span
                class="value"
                dangerouslySetInnerHTML={{ __html: option[0] }}
              ></span>
            </div>
            <div
              onClick={() =>
                user_key_state != 2
                  ? setUser_key_state(2)
                  : setUser_key_state(0)
              }
              class={`option ${user_key == 2 && "choice"} ${
                isAnswerPage && key_soal == 2 && "true_choice"
              }`}
            >
              <div class="circle">2</div>
              <span
                class="value"
                dangerouslySetInnerHTML={{ __html: option[1] }}
              ></span>
            </div>
            <div
              onClick={() =>
                user_key_state != 3
                  ? setUser_key_state(3)
                  : setUser_key_state(0)
              }
              class={`option ${user_key == 3 && "choice"} ${
                isAnswerPage && key_soal == 3 && "true_choice"
              }`}
            >
              <div class="circle">3</div>
              <span
                class="value"
                dangerouslySetInnerHTML={{ __html: option[2] }}
              ></span>
            </div>
            <div
              onClick={() =>
                user_key_state != 4
                  ? setUser_key_state(4)
                  : setUser_key_state(0)
              }
              class={`option ${user_key == 4 && "choice"} ${
                isAnswerPage && key_soal == 4 && "true_choice"
              }`}
            >
              <div class="circle">4</div>
              <span
                class="value"
                dangerouslySetInnerHTML={{ __html: option[3] }}
              ></span>
            </div>
          </div>

          {!isShowAnswer && location.pathname.split("/")[1] == "answer" && (
            <button
              className="btn btn-answer"
              onClick={() => {
                setIsShowAnswer(true);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                style={{ msFilter: "" }}
              >
                <path
                  fill="currentColor"
                  d="M10 15.586l-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"
                ></path>
              </svg>

              <span>مشاهده جواب</span>
            </button>
          )}
        </div>

        {isAnswerPage && isShowAnswer && (
            <MathJax>
        <div className="answer">
            <div
              className="text"
              dangerouslySetInnerHTML={{ __html: answer }}
            ></div>

            <div style={{ width: "100%" }}>
              <button
                className="btn btn-close"
                onClick={() => {
                  setIsShowAnswer(false);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M12 10.586l4.95-4.95 1.415 1.415-4.95 4.95 4.95 4.95-1.415 1.414-4.95-4.95-4.95 4.95-1.413-1.415 4.95-4.95-4.95-4.95L7.05 5.638l4.95 4.95z"
                  ></path>
                </svg>

                <span>بستن جواب</span>
              </button>
            </div>
          </div>
              </MathJax>
        )}
      </div>
    </MathJax>
  );
}

export default Soal;
